/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-18T17:50:47.993
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getKhmPayDeductionApplyEditInit,
	getKhmPayDeductionApplyView
} from '@api/storagemanage/KhmPayDeductionApply';

import {
listkhmPayDeductionApplyItemInit,
listkhmPayDeductionApplyItemByAuthorizations,
deletekhmPayDeductionApplyItem
} from '@api/storagemanage/khmPayDeductionApplyItem';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getKhmPayDeductionApplyEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getKhmPayDeductionApplyEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getKhmPayDeductionApplyView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getKhmPayDeductionApplyView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
